var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 748 408.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bfabd3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.55 408.11 75.55 34.37 164 120.3 176.34 48.43 201.32 112.49 265.82 0 312 105.14 345 62.14 370 105.14 417 25.14 434.92 107.8 500 11.14 555.39 128.11 604 50.14 616.73 143.75 682 39.14 682 408.11 619.67 408.11 583 241.14 177 239.14 129.05 408.11 75.55 408.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.55 408.11 0 217.14 75.55 259.67 22 117.14 99.54 155.99 75.55 408.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "667 167.14 730.23 117.14 682 262.62 748 238.14 682 408.11 667 167.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.34 262.62 188 285.14 210 229.14 155 215.14 170.34 262.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "561 228.14 554.68 329.82 608.88 250.14 602 198.14 561 228.14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset21);
export default __webpack_public_path__ + "static/media/Asset 21.f2c7b7c6.svg";
export { ForwardRef as ReactComponent };